<template>
  <div class="ma-6">
    <div class="maxh-4">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Veículo</th>
              <th>Módulo</th>
              <th>Organização</th>
              <th>Variáveis</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(vehicle, idx) in usage" :key="idx">
              <td>{{ vehicle.code }}</td>
              <td>{{ vehicle.clientId }}</td>
              <td>{{ vehicle.org && vehicle.org.name }}</td>
              <td>
                <div class="tag-list">
                  <span
                    v-for="v in vehicle.variables"
                    :key="v.code"
                    class="tag"
                    :class="v.color"
                  >
                    {{ v.code }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'

export default {
  tabTitle: 'Utilização',
  computed: {
    usage() {
      // NB:
      // Variáveis usadas e idênticas às atuais em cinza
      // Variáveis usadas e diferentes das atuais em amber
      // Variáveis usadas e atualmente removidas em strike-through
      return EditStore.usage
    }
  }
}
</script>

<style></style>
